import { initDraw } from './draw.js';
import { initView } from './view.js';
import './newsletter.js';
import { initAutoScroll } from './scoll.js';
import { initFaviconLoop } from './faviconLoop.js';
import { initPresence } from './presence.js';

function parseJsonDataAttr(element, attrName, fallback) {
  if (!element) return fallback;
  const raw = element.getAttribute(attrName);
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
}



function startViewAudio() {
  const audio = document.getElementById('viewAudio');
  if (!(audio instanceof HTMLMediaElement)) return;

  void audio.play().catch(() => {
    const onInteraction = () => {
      void audio.play().catch(() => {});
    };
    document.addEventListener('pointerdown', onInteraction, { once: true });
    document.addEventListener('keydown', onInteraction, { once: true });
  });
}

function initViewRoot(viewRoot) {
  initView({
    shapeKeys: parseJsonDataAttr(viewRoot, 'data-shape-keys', []),
    initialShape: viewRoot.getAttribute('data-initial-shape') || 'star',
    defaultViewShape: viewRoot.getAttribute('data-default-view-shape') || 'star',
  });
  initAutoScroll({
    speedPxPerSecond: 45,
  });
  startViewAudio();
}

async function switchToViewInline(shape) {
  const drawRoot = document.getElementById('drawApp');
  if (!drawRoot) {
    return false;
  }

  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set('mode', 'view');

  const response = await fetch(nextUrl.toString(), {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
  if (!response.ok) {
    return false;
  }

  const html = await response.text();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const nextViewRoot = parsed.getElementById('viewApp');
  if (!nextViewRoot) {
    return false;
  }

  const nextStylesheet = parsed.querySelector('head link[rel="stylesheet"]');
  const currentStylesheet = document.querySelector('head link[rel="stylesheet"]');
  if (nextStylesheet && currentStylesheet) {
    const nextHref = nextStylesheet.getAttribute('href');
    if (nextHref) {
      currentStylesheet.setAttribute('href', nextHref);
    }
  }

  drawRoot.replaceWith(nextViewRoot);
  window.history.pushState({}, '', nextUrl.toString());
  initViewRoot(nextViewRoot);
  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  const drawRoot = document.getElementById('drawApp');
  const viewRoot = document.getElementById('viewApp');
  const presenceBadge = document.getElementById('presenceBadge');

//   initFaviconLoop({
//     text: 'DE PARADE MAKEN WE SAMEN',
//     frameMs: 220,
//     backgroundColor: '#FD95FA',
//     pathColor: '#585A11',
//   });

  if (presenceBadge) {
    initPresence({ badge: presenceBadge });
  }

  if (drawRoot) {
    initDraw({
      assignments: parseJsonDataAttr(drawRoot, 'data-assignments', {}),
      appMode: drawRoot.getAttribute('data-app-mode') || 'test',
      drawMaxPathLength: Number(drawRoot.getAttribute('data-draw-max-path-length') || 3900),
      onLiveViewTransition: async ({ shape }) => switchToViewInline(shape),
    });
  }

  if (viewRoot) {
    initViewRoot(viewRoot);
  }
});
